export default __webpack_public_path__ + "static/media/discord-logo.3f10e46a.svg";